exports = module.exports = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".IA_permissionsEditPanel_1wYD49HkZBIF_GoS3ADmrT {\n  position: relative;\n  width: 100%;\n  float: left;\n}\n\n.IA_content_7ojt7wymJqOdp1vQqmU22 {\n  position: relative;\n  float: left;\n  width: 400px;\n  height: 100%;\n  padding-left: 40px;\n  box-sizing: border-box;\n}\n\n.IA_permissionsSearchResult_6S_Dc6yLqGgq8zIuL-fA2 {\n  margin-top: 100px;\n  clear: both;\n}", ""]);

// Exports
exports.locals = {
	"IA_permissionsEditPanel": "IA_permissionsEditPanel_1wYD49HkZBIF_GoS3ADmrT",
	"IA_content": "IA_content_7ojt7wymJqOdp1vQqmU22",
	"IA_permissionsSearchResult": "IA_permissionsSearchResult_6S_Dc6yLqGgq8zIuL-fA2"
};